import axios from "axios";

import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

import {closableNotification} from "../../../elements/notification/ClosableNotification";

import Dialog from "rc-dialog";

import {AppContext} from "../../../../App";

import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import {responseStatus} from "../../../../utils/consts";
import {useBetween} from "use-between";
import ProfileActionsStates from "../../ProfileActionsStates";
import loadingGif from "../../../../assets/images/loading.gif";
import {NavLink} from "react-router-dom";
import {generatePath} from "../../../../utils/getLanguage";
import userIcon from "../../../../assets/images/user_icon_dark.svg";
import {
    EmptyTable,
    StyledBanListTable, StyledBanListTableBody,
    StyledBanListTableHead, StyledBanListTableItem, StyledBanListTableRow,
    StyledModalLoader,
    StyledWrapperTable
} from "./styledViolatorsInfoModal";
import UserTag, {tagRegex as userTagRegex} from "../../../elements/tags/UserTag";
import {renderToStaticMarkup} from "react-dom/server";
import BetTag, {tagRegex as betTagRegex} from "../../../elements/tags/BetTag";
import CurrencyTag, {tagRegex as currencyTagRegex} from "../../../elements/tags/CurrencyTag";
import EmojiTag, {tagRegex as emojiTagRegex} from "../../../elements/tags/EmojiTag";
import {decodeMessage} from "../../../elements/leftSidebar/Chat/utils";

function ViolatorsInfoModal() {
    const {t} = useTranslation("siteOptions");

    const [violatorsInfoData, setViolatorsInfoData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const {authenticated} = useContext(AppContext);

    const {setVisibleViolatorsInfoModal, visibleViolatorsInfoModal} = useBetween(ProfileActionsStates);

    const getViolatorsInfoList = () => {
        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_MODERATOR_LINK}/chat-violators/get-violators-list`, userAuthenticationConfig()).then(response => {
            if (response.status === responseStatus.HTTP_OK) {
                setViolatorsInfoData(response.data);
                setIsLoading(false);
            }
        }).catch(error => {
            closableNotification(error.response.data.message, "error");
            setIsLoading(false);
            setVisibleViolatorsInfoModal(false);
        });
    };

    useEffect(() => {
        if (!visibleViolatorsInfoModal || !authenticated) return;
        getViolatorsInfoList();
    }, [visibleViolatorsInfoModal])

    const processBeforeOutput = (value, user) => {
        if (typeof value === 'string') {
            value = value.replace(userTagRegex, (substr, username) => {
                const isCurrentUser = user === username;
                const hintData = !isCurrentUser ? {
                    "data-custom": true,
                    "data-custom-at": "right",
                    "data-id": window.crypto.getRandomValues(new Uint8Array(10)).join(''),
                    "data-nickname": username,
                } : {};
                return renderToStaticMarkup(<UserTag username={username} isCurrentUser={isCurrentUser}
                                                     hintData={hintData}/>);
            });
            value = value.replace(betTagRegex, (substr, id) => renderToStaticMarkup(<BetTag id={id}/>));
            value = value.replace(currencyTagRegex, (substr, coinName) => renderToStaticMarkup(
                <CurrencyTag coinSymbol={coinName}/>));
            value = value.replace(emojiTagRegex, (substr, emojiCode) => renderToStaticMarkup(<EmojiTag
                emojiCode={emojiCode}/>));
        }
        return decodeMessage(value);
    }

    const processedViolatorReq = (violatorId) => {
        axios.put(`${process.env.REACT_APP_MODERATOR_LINK}/chat-violators/processed-violator/${violatorId}`, {}, userAuthenticationConfig()).then(response => {
        }).catch(error => {
            closableNotification(error.response.data.message, "error");
        });
    };


    async function onChangeCheckBox(event, violatorId) {
        const {checked} = event.target;
        setViolatorsInfoData(prev =>
            prev.map(item =>
                item.id === violatorId
                    ? {...item, is_processed: checked}
                    : item
            )
        );

        try {
            await processedViolatorReq(violatorId);
        } catch (error) {
            setViolatorsInfoData(prev =>
                prev.map(item =>
                    item.id === violatorId
                        ? {...item, is_processed: !checked}
                        : item
                )
            );
            closableNotification(
                error.response?.data?.message || 'Ошибка при обновлении',
                'error'
            );
        }
    }

    return (
        <Dialog
            visible={authenticated && visibleViolatorsInfoModal}
            wrapClassName="default-modal-wrapper"
            onClose={() => setVisibleViolatorsInfoModal(false)}
            animation="zoom"
            maskAnimation="fade"
            title={t("violatorsInfoModal")}
            forceRender={false}
            className="default-modal violators-info-modal"
            style={{margin: "auto"}}
        >
            {isLoading || !violatorsInfoData ?
                <StyledModalLoader style={{height: "200px", minHeight: "auto", margin: "auto"}}><img
                    src={loadingGif} alt={"loading..."}/></StyledModalLoader> :
                violatorsInfoData?.length === 0 ? <EmptyTable>{t("noBans")}</EmptyTable> :
                    <StyledWrapperTable>
                        <StyledBanListTable>
                            <StyledBanListTableHead>
                                <StyledBanListTableRow>
                                    <StyledBanListTableItem>{t("user")}</StyledBanListTableItem>
                                    <StyledBanListTableItem>{t("IP")}</StyledBanListTableItem>
                                    <StyledBanListTableItem>{t("message")}</StyledBanListTableItem>
                                    <StyledBanListTableItem>{t("user")}</StyledBanListTableItem>
                                    <StyledBanListTableItem>{t("IP")}</StyledBanListTableItem>
                                    <StyledBanListTableItem>{t("message")}</StyledBanListTableItem>
                                    <StyledBanListTableItem></StyledBanListTableItem>
                                </StyledBanListTableRow>
                            </StyledBanListTableHead>
                            <StyledBanListTableBody>
                                {violatorsInfoData?.map((violatorsData, key) => (
                                    <StyledBanListTableRow key={key}>
                                        <StyledBanListTableItem>
                                            <NavLink
                                                to={generatePath(`/account/${violatorsData?.firstMessage?.user?.nickname}`)}
                                                onClick={() => setVisibleViolatorsInfoModal(false)}
                                                className="wrapper-link"
                                            >
                                                <img
                                                    src={userIcon}
                                                    alt="user"
                                                />
                                                {violatorsData?.firstMessage?.user?.nickname}
                                            </NavLink>
                                        </StyledBanListTableItem>
                                        <StyledBanListTableItem
                                            style={{maxWidth: "140px"}}>{violatorsData?.first_ip}</StyledBanListTableItem>
                                        <StyledBanListTableItem
                                            dangerouslySetInnerHTML={{__html: processBeforeOutput(violatorsData?.secondMessage?.value, violatorsData?.user)}}
                                            style={{maxWidth: "140px"}}/>
                                        <StyledBanListTableItem>
                                            <NavLink
                                                to={generatePath(`/account/${violatorsData?.secondMessage?.user?.nickname}`)}
                                                onClick={() => setVisibleViolatorsInfoModal(false)}
                                                className="wrapper-link"
                                            >
                                                <img
                                                    src={userIcon}
                                                    alt="user"
                                                />
                                                {violatorsData?.secondMessage?.user?.nickname}
                                            </NavLink>
                                        </StyledBanListTableItem>
                                        <StyledBanListTableItem>{violatorsData?.first_ip}</StyledBanListTableItem>
                                        <StyledBanListTableItem
                                            dangerouslySetInnerHTML={{__html: processBeforeOutput(violatorsData?.secondMessage?.value, violatorsData?.user)}}
                                            style={{maxWidth: "140px"}}/>
                                        <StyledBanListTableItem>
                                            <div className="flex-inline">
                                                <input
                                                    type="checkbox"
                                                    id={`processed-${violatorsData.id}`}
                                                    className="checkbox__input"
                                                    checked={violatorsData?.is_processed}
                                                    value={violatorsData?.is_processed}
                                                    name={"is_processed"}
                                                    onChange={e => onChangeCheckBox(e, violatorsData.id)}
                                                    style={{cursor: "pointer"}}
                                                />
                                                <label htmlFor={`processed-${violatorsData.id}`} className="custom-checkbox" />
                                            </div>
                                        </StyledBanListTableItem>
                                    </StyledBanListTableRow>
                                ))}
                            </StyledBanListTableBody>
                        </StyledBanListTable>
                    </StyledWrapperTable>
            }
        </Dialog>
    )
}

export default ViolatorsInfoModal;